import { useState } from "react";
import { styled } from "@xstyled/styled-components";
import { useNavigate } from "react-router-dom";

import { JobSlotsModal } from "../JobSlots/JobSlotsModal";

import { VideoContent } from "@hire/components/VideoContent";
import { Button, Heading, Spacing } from "@otta/design";
import { palette, pxToRem } from "@otta/design-tokens";

const DotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${pxToRem(8)};
  margin: ${pxToRem(16)} 0;
  align-items: center;
`;

const Dot = styled(Button)<{ active: boolean }>`
  width: ${({ active }) => (active ? pxToRem(9) : pxToRem(7))};
  height: ${({ active }) => (active ? pxToRem(9) : pxToRem(7))};
  border-radius: 50%;
  border: none;
  background-color: ${({ active }) =>
    active ? palette.brand.black : palette.brand.grey};
  cursor: pointer;
  padding: 0;
`;

const NavButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: ${pxToRem(20)};
`;

const NavButton = styled(Button)`
  width: ${pxToRem(180)};
`;

const Footer = styled.div``;

const Content = styled.div`
  flex: 1 1 0%;
`;

export function PAYGInfoModal({
  videos,
  name,
}: {
  videos: { videoUrl: string; children: React.ReactNode; heading: string }[];
  name: string;
}): React.ReactElement | null {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);

  const handleDotClick = (index: number) => setCurrentVideoIndex(index);
  const handleNext = () =>
    setCurrentVideoIndex(prev => Math.min(prev + 1, videos.length - 1));
  const handleBack = () => setCurrentVideoIndex(prev => Math.max(prev - 1, 0));
  const navigate = useNavigate();

  return (
    <JobSlotsModal name={name} redirectOnClose="/jobs">
      <Content>
        <Spacing size={1}>
          <Heading size={2}>{videos[currentVideoIndex].heading}</Heading>
          <VideoContent
            videoUrl={videos[currentVideoIndex].videoUrl}
            videoAnalyticsCategory={`PAYG Info Modal - ${videos[currentVideoIndex].heading}`}
          >
            {videos[currentVideoIndex].children}
          </VideoContent>
        </Spacing>
      </Content>
      <Footer>
        <DotsWrapper>
          {videos.map((_, index) => (
            <Dot
              level="secondary"
              key={index}
              active={index === currentVideoIndex}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </DotsWrapper>
        <NavButtonsWrapper>
          {currentVideoIndex !== 0 && (
            <NavButton onClick={handleBack} level="secondary">
              Back
            </NavButton>
          )}
          {currentVideoIndex === videos.length - 1 ? (
            <NavButton onClick={() => navigate("/jobs")} level="primary">
              Continue
            </NavButton>
          ) : (
            <NavButton onClick={handleNext} level="primary">
              Next
            </NavButton>
          )}
        </NavButtonsWrapper>
      </Footer>
    </JobSlotsModal>
  );
}
